import BaseComponent from "./BaseComponent";
import { Constant } from '../const';

export default class ScopeHint extends BaseComponent {
    /**
     * Hints about scope keywords
     * @module ScopeHint
     * @param {Object} props React props
     */
    constructor(props){
        super(props);
    }

    render(){
        return (
            <div className={"form-component-container"}>
                <label>{this.getPropLabel("scopes")}</label>
                <table>
                    <tbody>
                    <tr><td><b>{Constant.k.SCOPE_APPLICATION}&nbsp;&nbsp;</b></td><td>{this.getPropLabel("application")}</td></tr>
                    <tr><td><b>{Constant.k.SCOPE_MODULE}&nbsp;&nbsp;</b></td><td>{this.getPropLabel("module_local")}</td></tr>
                    {this.props.link &&
                    <tr><td><b>{Constant.k.SCOPE_OUTPUT}&nbsp;&nbsp;</b></td><td>{this.getPropLabel("previous_node")}</td></tr>
                    }
                    </tbody>
                </table>
            </div>
        );
    }
}